export default __webpack_public_path__ + "static/hackathon-header-031fc68b97dd2e71f3cbd57630e3ec42.jpg";